import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import { Platform } from "react-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  manVan: {
    justifyContent: "center",
    flex: 1,
    height: Platform.OS == "web" ? "100%" : undefined,
  },
  CTAHeading: createResponsiveStyles({
    base: {
      textAlign: "center",
      color: theme.colors.brand.base,
      marginBottom: theme.spacing.small,
      paddingHorizontal: theme.spacing.xlarge2,
    },
    medium: {
      paddingHorizontal: 0,
    },
  }),
  manVanHeading: {
    color: theme.colors.brand.base,
    textAlign: "center",
    flex: 1,
    marginLeft: theme.spacing.small,
  },
  manVanPanel: {
    alignItems: "center",
    justifyContent: "space-around",
    flexDirection: "row",
  },
  manVanImage: {
    width: 90,
    height: 90,
    marginLeft: theme.spacing.medium,
  },
  button: {
    width: "100%",
    maxWidth: 200,
    margin: "auto",
    marginBottom: theme.spacing.small,
  },
  CTAImage: {
    width: "100%",
    height: "100%",
  },
});
